

<body>
<button><a routerLink="" routerLinkActive="active">back</a></button>
  
<div class ="header">Computer Science</div>

  


<div class="row">
  <div class="col-lg-12 mx-auto">
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
      <div class="btn-group mr-2" role="group" aria-label="First group">
        <button type="button" class="btn btn-secondary"><a routerLink="computerparts" style="color:black">Hardware</a></button>
      </div>
      <div class="btn-group mr-2" role="group" aria-label="Second group">
        <button type="button" class="btn btn-secondary">Softwear</button>
      </div>
      <div class="btn-group mr-2" role="group" aria-label="Second group">
        <button type="button" class="btn btn-secondary">Storage devices</button>
      </div>
    </div>
  </div>
</div>



<mat-form-field class= "select">
  <input (keyup) ="applyFilter($event.target.value)" matInput placeholder="Search">
</mat-form-field>




 
<mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <!-- Position Column -->
  <ng-container matColumnDef="position">
    <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
    <mat-cell *matCellDef="let Computer"> {{Computer.position}} </mat-cell>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="Inputdevices">
    <mat-header-cell *matHeaderCellDef>Input devices </mat-header-cell>
    <mat-cell *matCellDef="let Computer"> {{Computer.Inputdevices}} </mat-cell>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="Outputdevices">
    <mat-header-cell *matHeaderCellDef>Output devices </mat-header-cell>
    <mat-cell *matCellDef="let Computer"> {{Computer.Outputdevices}} </mat-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="Storagedevices">
    <mat-header-cell *matHeaderCellDef> Storage devices </mat-header-cell>
    <mat-cell *matCellDef="let Computer"> {{Computer.Storagedevices}} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<!--<mat-form-field>
<input (keyup) ="applyFilter($event.target.value)" matInput placeholder="Filter">
</mat-form-field>-->

</body>
